import { fetch, strategies } from 'app/utils/data'
import deserialize from 'app/utils/deserialize'

export default {
  namespaced: true,

  state: {
    document: null
  },

  getters: {
    document: (state) => state.document
  },

  mutations: {
    fetchedDocument(state, { documentDefinition }) {
      state.document = documentDefinition
    },

    resetState(state) {
      // noop
    }
  },

  actions: {
    async fetchDocument({ commit }, { version, where, group, name }) {
      const response = await fetch({
        url: `/api/document-definitions/${where}/${group}/${name}`,
        params: {
          version
        },
        type: 'document-definition',
        strategies: [strategies.INLINE, strategies.XHR]
      })
      const documentDefinition = await deserialize(response.data)

      commit('fetchedDocument', { documentDefinition })

      return documentDefinition
    }
  }
}
